module.exports = __webpack_public_path__ + "img/216-241527.png";